<template>
  <div class="row">
    <div class="col-12">
      <div v-if="text" class="separator-custom">
        <span class="text active" style="cursor: pointer;">{{ text }}</span>
      </div>
      <div v-else class="separator-custom">
        <span
          v-for="(option, idx) in options"
          :key="option.name"
          style="cursor: pointer;"
          :data-id="`${option.id ? option.id : idx}`"
          :class="`text fixed ${option.class} ${option.active ? 'active' : ''}`"
          @click="changeOption(idx)"
        >
          {{ option.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSeparator',
  meta: {
    description: 'Componente común separador, personalizado con título.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    text: {
      type: String,
      default: () => null,
      meta: {
        description: 'Título mostrado en el componente ',
        example: 'Texto requerido',
      },
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    changeOption(idx) {
      this.options.forEach((element) => {
        element.active = false;
      });

      let selectedOption = this.options[idx];

      selectedOption.active = true;

      this.$emit('selected', selectedOption.id ? selectedOption.id : idx);

      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.separator-custom {
  display: flex;
  align-items: center;
  text-align: center;
  font: 700 17px/23px Lato;
}

.separator-custom .text:first-child {
  border-top-left-radius: 21px;
  border-bottom-left-radius: 21px;
}

.separator-custom .text:last-child {
  border-top-right-radius: 21px;
  border-bottom-right-radius: 21px;
}

.separator-custom .text {
  color: #727272;
  background: #e2e2e2 0% 0% no-repeat padding-box;
  padding: 5px 16px;
}

.separator-custom .text.active {
  color: #fff;
  background: #3f5b60 0% 0% no-repeat padding-box;
}

.separator-custom::before,
.separator-custom::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
  margin-right: 15px;
  margin-left: 15px;
}

@media screen and (max-width: 480px) {
  .separator-custom {
    flex-direction: column;
  }

  .separator-custom .text {
    border-radius: 21px;
  }

  .fixed {
    width: 100%;
    margin-bottom: 2%;
  }
}
</style>
